/* @ngInject */
export function RedirectDirective($document) {
    return {
        restrict: 'E',
        scope: {
            redirectUrl: '=',
            payload: '='
        },
        link: function (scope) {
            let document = $document[0];
            let form = document.createElement('form');
            form.action = scope.redirectUrl;
            form.method = 'post';
            form.className += ' hidden';
            for (let key in scope.payload) {
                if (scope.payload.hasOwnProperty(key)) {
                    let inputField = document.createElement('input');
                    inputField.type = 'text';
                    inputField.name = key;
                    inputField.value = scope.payload[key];
                    form.appendChild(inputField);
                }
            }
            document.body.appendChild(form);
            form.submit();
        }
    };
}
